import { render, staticRenderFns } from "./departments.vue?vue&type=template&id=435307f0&scoped=true"
import script from "./departments.vue?vue&type=script&lang=ts"
export * from "./departments.vue?vue&type=script&lang=ts"
import style0 from "./departments.vue?vue&type=style&index=0&id=435307f0&prod&lang=css"
import style1 from "./departments.vue?vue&type=style&index=1&id=435307f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435307f0",
  null
  
)

export default component.exports